export default {
  KG: "kg",
  LBS: "lbs",
} as const;
